import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import Button from "@atlaskit/button";

import { useSiteActivationContext } from "@/components/signup/site-activation/hooks/site-activation-context";
import { wacToken } from "@/libraries/design/foundations";

import { PaymentDetailsHeading } from "..";

export const PaymentDetailsContent = () => {
    const { setPaymentDetailsView, activateSite } = useSiteActivationContext();
    const handleSubmit = () => {
        const privacyPolicy =
            document.getElementById("privacy-policy-text")?.innerHTML || "";
        activateSite({ privacyPolicy });
    };

    return (
        <>
            <PaymentDetailsHeading />
            <p css={subtitleCss}>
                <FormattedMessage
                    id="BxpSignup.PaymentDetailsSubtitle"
                    defaultMessage="to start a Rovo Dev 30 day free trial"
                />
            </p>
            <div css={actionsCss}>
                <Button
                    appearance="default"
                    onClick={() =>
                        setPaymentDetailsView({ view: "site-setup" })
                    }
                >
                    <FormattedMessage
                        id="BxpSignup.PaymentDetailsBack"
                        defaultMessage="Back"
                    />
                </Button>
                <Button appearance="primary" onClick={handleSubmit}>
                    <FormattedMessage
                        id="BxpSignup.PaymentDetailsSubmit"
                        defaultMessage="I've added my payment details"
                    />
                </Button>
            </div>
        </>
    );
};

const subtitleCss = css({
    color: wacToken("color.neutral.dark400"),
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.5,
    margin: "0 0 24px",
    textAlign: "center"
});

const actionsCss = css({
    display: "flex",
    gap: 16,
    justifyContent: "center",
    padding: "12px"
});
